import { Component, Input } from "@angular/core"
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from "@angular/cdk/scrolling";
import { MatIcon } from "@angular/material/icon"
@Component({
    selector: "valben-virtual-listbox",
    templateUrl: "./virtual-listbox.component.html",
    standalone: true,
    imports: [
        CdkVirtualScrollViewport,
        CdkFixedSizeVirtualScroll,
        CdkVirtualForOf,
        MatIcon,
    ],
})
export class VirtualListBoxComponent {
    @Input() title: string = ""
    @Input() items: string[] = []

    filterItems: string[] = []
    filtering: boolean = false

    filter(val: string) {
        if (!val) {
            this.filtering = false
            this.filterItems = this.items
        } else {
            this.filtering = true
            this.filterItems = this.items.filter(el => el.toLowerCase().includes(val.toLowerCase()))
        }
    }
}
